import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';

export const Box21_Diagnosis: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">
        21. DIAGNOSIS OR NATURE OF ILLNESS OR INJURY (Relate A-L to service line below)
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography variant="caption">ICD Ind.</Typography>
        <Controller
          name="icdIndicator"
          control={control}
          render={({ field: { disabled, ...restField } }) => (
            <Tooltip title={!disabled ? "Currently only ICD-10 is supported" : ""} placement="top">
              <RadioGroup {...restField} row>
                <FormControlLabel value="9" control={<Radio size="small" disabled={true} />} label="9" />
                <FormControlLabel value="0" control={<Radio size="small" disabled={true} />} label="10" />
              </RadioGroup>
            </Tooltip>
          )}
        />
      </Box>
      <Box sx={formStyles.diagnosisGrid}>
        {(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'] as const).map(
          letter => (
            <Box key={letter} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography variant="caption">{letter}.</Typography>
              <Controller
                name={`diagnosisCodes.${letter}`}
                control={control}
                render={({ field, fieldState }) => (
                  <ClaimTextField
                    field={field}
                    fieldState={fieldState}
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Box>
          ),
        )}
      </Box>
    </>
  );
};